module.exports = __webpack_public_path__ + "img/ic-smartplug.73c44366.svg";